"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeCarValidationSchema = makeCarValidationSchema;
const Yup = __importStar(require("yup"));
/**
 * Limity długości odpowiadają kolumnom w tabeli Cars - MariaDB obcięłaby dłuższą
 * wartość po cichu, więc lepiej zatrzymać ją tutaj.
 */
const commonFields = {
    brand: Yup.string().required("Podaj markę").max(50, "Marka może mieć maksymalnie 50 znaków"),
    model: Yup.string().required("Podaj model").max(50, "Model może mieć maksymalnie 50 znaków"),
    licensePlateNumber: Yup.string()
        .required("Podaj numer rejestracyjny ")
        .max(15, "Numer rejestracyjny może mieć maksymalnie 15 znaków"),
    mileageSpreadsheetId: Yup.string()
        .nullable()
        .notRequired()
        .max(100, "Identyfikator arkusza może mieć maksymalnie 100 znaków"),
    mileageSheetGid: Yup.number()
        .nullable()
        .notRequired()
        .transform((value, original) => (original === "" || original === null ? null : value))
        .integer("Numer zakładki musi być liczbą całkowitą"),
    comment: Yup.string().nullable().notRequired().max(300, "Uwagi mogą mieć maksymalnie 300 znaków"),
};
function makeCarValidationSchema(isEditing) {
    return Yup.object().shape({
        ...commonFields,
    });
}
